// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Bot_Filled_Corner0_Rounded = createSinglePathSVG({
  path: 'M18.75 4.5h-6v-3a.75.75 0 0 0-1.5 0v3h-6a3 3 0 0 0-3 3V18a3 3 0 0 0 3 3h13.5a3 3 0 0 0 3-3V7.5a3 3 0 0 0-3-3ZM16.125 9A1.125 1.125 0 1 1 15 10.125 1.125 1.125 0 0 1 16.125 9ZM9 17.25H7.5a1.5 1.5 0 0 1 0-3H9Zm-1.125-6A1.125 1.125 0 1 1 9 10.125a1.125 1.125 0 0 1-1.125 1.125Zm5.625 6h-3v-3h3Zm3 0H15v-3h1.5a1.5 1.5 0 0 1 0 3Z',
  viewBox: '0 0 24 24',
  glyph: 'Bot_Filled_Corner0_Rounded',
})

export const Bot_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M18.75 4.5h-6v-3a.75.75 0 0 0-1.5 0v3h-6a3 3 0 0 0-3 3V18a3 3 0 0 0 3 3h13.5a3 3 0 0 0 3-3V7.5a3 3 0 0 0-3-3Zm1.5 13.5a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V7.5A1.5 1.5 0 0 1 5.25 6h13.5a1.5 1.5 0 0 1 1.5 1.5Zm-4.875-5.25h-6.75a2.625 2.625 0 0 0 0 5.25h6.75a2.625 2.625 0 0 0 0-5.25Zm-2.25 1.5v2.25h-2.25v-2.25ZM7.5 15.375a1.125 1.125 0 0 1 1.125-1.125h.75v2.25h-.75A1.125 1.125 0 0 1 7.5 15.375Zm7.875 1.125h-.75v-2.25h.75a1.125 1.125 0 0 1 0 2.25ZM6.75 10.125a1.125 1.125 0 1 1 1.125 1.125 1.125 1.125 0 0 1-1.125-1.125Zm8.25 0a1.125 1.125 0 1 1 1.125 1.125A1.125 1.125 0 0 1 15 10.125Z',
  viewBox: '0 0 24 24',
  glyph: 'Bot_Stroke2_Corner0_Rounded',
})
